import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { translatedMessage } from '../../service/LanguageService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RecruitmentPlanToolbar = (props) => {
    const [recruitmentPlan, setRecruitmentPlan] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const _sections = [
        { label: translatedMessage('generic.details'), code: 'DETAIL', icon: 'fa-regular fa-eye', url: "/" },
        { label: translatedMessage('recruitment.plan.execution.title'), code: 'EXECUTIE', icon: 'fa-solid fa-pen-nib', url: "/exec" },
        { label: translatedMessage('recruitment.plan.management.title'), code: 'CONDUCERE', icon: 'fa-solid fa-suitcase', url: `/manag` },
        { label: translatedMessage('recruitment.plan.ifp.title'), code: 'INALTI_FUNCTIONARI_PUBLICI', icon: 'fa-solid fa-award', url: "/ifp" },
        { label: translatedMessage('recruitment.plan.promotion.management.title'), code: 'PROMOVARE_CONDUCERE', icon: 'fa-solid fa-stairs', url: "/prom-manag" },
        { label: translatedMessage('generic.backToList'), code: 'BACK', icon: 'fa-solid fa-arrow-left' }
    ];
    
    let _section = props ? _sections.filter(item => item.code === props.code)[0] : _sections[0];
    const [section, setSection] = useState(_section);
    const [sections] = useState(_sections);
    

    const navigate = useNavigate();

    useEffect(() => {
        setRecruitmentPlan(props?.recruitmentPlan)        
        setIsLoading(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const navigationTemplate = (option) => {
        return (
            <div className='flex align-items-center'>
                <FontAwesomeIcon icon={option.icon} className="mr-1 " />
                <span>{option.label}</span>
            </div>
        )
    }

    const handleSelectButtonChange = (value) => {
        let url = null
        if (value) {
            if (value.code === 'BACK') {
                navigate(`/recruitment-plan`);
            } else {
                if (value && value.url && value.url !== '#') {
                    url = `/recruitment-plan/${recruitmentPlan?.id}${value.url}`
                    navigate(url);
                } else {
                    setSection(value)
                }
            }
        }
    }

    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <SelectButton
                    value={section}
                    options={sections}
                    onChange={(e) => handleSelectButtonChange(e.value)}
                    itemTemplate={navigationTemplate}
                    className="pcn-selectbutton mb-3"
                />

            </>
        );
    }
};

export default RecruitmentPlanToolbar;
